// The Shortcuts list in the sidebar: application hosts this person pinned. Query keys live in
// ./queries so target and project change events can invalidate them through invalidationsFor().

import { useQuery } from '@tanstack/react-query';
import type { ShortcutDTO } from '@devrobot/shared';
import { api, seg } from './client';
import { qk, useApiMutation } from './queries';

/**
 * Every host this user pinned. The sidebar keeps this loaded on every page, so the target screen
 * reads pinned state out of this cache rather than asking again.
 */
export const useShortcuts = () => useQuery({ queryKey: qk.shortcuts, queryFn: () => api.get<ShortcutDTO[]>('/api/v1/shortcuts'), staleTime: 60_000 });

export const useAddShortcut = () =>
  useApiMutation((v: { targetId: string; url: string }) => api.post<ShortcutDTO>('/api/v1/shortcuts', v), { invalidate: [qk.shortcuts] });

export const useRemoveShortcut = () => useApiMutation((id: string) => api.delete<void>(`/api/v1/shortcuts/${seg(id)}`), { invalidate: [qk.shortcuts] });

/** Endpoint URL → shortcut id, for the hosts of one deployment. */
export function pinnedByUrl(items: ShortcutDTO[] | undefined, targetId: string): Map<string, string> {
  const out = new Map<string, string>();
  for (const s of items ?? []) if (s.targetId === targetId) out.set(s.url, s.id);
  return out;
}
